import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';
class UserCreatedData extends Component {
    constructor() {
        super();
        this.state = {
            editUserFlag: false
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.editUserFlag !== prevProps.editUserFlag) {
            this.setState({
                editUserFlag: this.props.editUserFlag
            })
        }
    }
    handleEditUserDetails = (userData) => {
        this.props.userCreatedDataCallback(userData);
        this.setState({
            editUserFlag: true
        })
    }
    deleteUserDetails = (event, userData) => {
        this.props.deleteUserData(userData);
    }
    render() {
        return (
            <div>
                <Row noGutters className="mb-3 custom-table-header d-none d-sm-flex align-items-center">
                    <Col sm="24" className="px-2">
                        <Row noGutters className="align-items-center">
                            <Col sm="5" className="custom-table-header-title px-2 py-3">First Name</Col>
                            <Col sm="4" className="custom-table-header-title px-2 py-3">Last Name </Col>
                            <Col sm="6" className="custom-table-header-title px-2 py-3 text-sm-center d-flex align-items-center cursor-pointer">Email</Col>
                            <Col sm="5" className="custom-table-header-title px-2 py-3 text-sm-center cursor-pointer" title="Risk Level">Contact No</Col>
                            <Col sm="4" className="custom-table-header-title px-2 py-3 text-sm-center cursor-pointer" title="Risk Level">Action</Col>
                        </Row>
                    </Col>

                </Row>
                <ul className="border-bottom mb-4">
                    {
                        this.props.allUsers.map(userItem => {
                            if (userItem.enabled) {
                                return (
                                    <li key={userItem.email}>
                                        <Row key={userItem.email} >
                                            <Col xs="5" className="d-flex align-items-center pl-5 pr-2"><a href="javascript:void(0)" style={this.state.editUserFlag ? { pointerEvents: "none" } : null} onClick={() => this.handleEditUserDetails(userItem)}><span>{userItem.firstName}</span></a>
                                                {/* <Button size="sm" color="link" onClick={(event) => this.loadUserDetails(event, userItem)}>{userItem.firstName + ' ' + userItem.lastName}</Button> */}
                                            </Col>
                                            <Col xs="4" className="d-flex align-items-center pl-4 pr-1"><span>{userItem.lastName}</span></Col>
                                            <Col xs="6" className="d-flex align-items-center pl-4 pr-1 text-break"><span>{userItem.email}</span></Col>
                                            <Col xs="5" className="d-flex align-items-center pl-4 pr-1"><span>{userItem.contactNo}</span></Col>
                                            <Col xs="4" className="text-center d-flex align-items-center p-0" onClick={(event) => this.deleteUserDetails(event, userItem)}><Button className="btn-transparent p-0 shadow-none"><i className="icon-close text-danger"></i></Button></Col>
                                        </Row>
                                    </li>
                                )
                            }
                        })}
                </ul>
            </div>
        )
    }
}

export default UserCreatedData;